import { START_PAGE } from "@/constants/pagination";
import { DEFAULT_VISIBLE_COLUMNS } from "@/features/organization/constants/organizationList";
import { TOrganizationFilterCache } from "@/features/organization/types/organizationFilter";

export const STORAGE_KEY = "organizationFilterCache";

export const DEFAULT_FILTER: TOrganizationFilterCache = {
  page: START_PAGE,
  externalId: "",
  name: "",
  productId: "",
  lastLoginFrom: null,
  lastLoginTo: null,
  createdDateFrom: null,
  createdDateTo: null,
  search: "",
  visibleColumns: DEFAULT_VISIBLE_COLUMNS,
  columnOrder: Object.keys(DEFAULT_VISIBLE_COLUMNS),
  status: "",
};

export const FILTER_ACTION = {
  RESET: "reset",
  CLEAR: "clear",
} as const;

export const FILTER_TAB = {
  FILTER: "filter",
  DISPLAY_SETTINGS: "displaySettings",
} as const;

export const FILTER_TAB_OPTIONS = [
  { label: "フィルタ", value: FILTER_TAB.FILTER },
  { label: "表示項目設定", value: FILTER_TAB.DISPLAY_SETTINGS },
];
